<template>
  <div class="q-row autocomplete-popup__container">
    <SuggestionsContainer v-if="suggestionsEnabled && !matchedRedirect"/>
    <p v-if="hasNoResults && !matchedRedirect" class="autocomplete-popup__no-results">
      {{ SmartSearchTranslations.autocomplete.noResults }}: <b>{{ searchQuery }}</b>
    </p>
    <div id="autocompleteResults" class="autocomplete-popup__results-container"
         :class="{
       'q-col-md-12 q-pt-1': matchedRedirect || !suggestionsEnabled,
       'q-col-12 q-col-md-9 q-pt-1': !matchedRedirect && suggestionsEnabled
     }">
      <ProductsContainer
          :products-header="matchedRedirect ? 'Znaleźliśmy stronę odpowiadającą Twojemu zapytaniu' : SmartSearchTranslations.autocomplete.resultsHeader"
          :section-enabled="true"
          :promoted-product-enabled="bestsellerEnabled && !matchedRedirect"
          :promoted-product="getBestseller"
          :promoted-product-header="SmartSearchTranslations.autocomplete.bestsellerHeader"
          :products-list="results"
          :can-show-promoted-section="canShowPromotedSection && !matchedRedirect"
      />
      <MoreResultsButton v-if="!matchedRedirect"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProductsContainer from '@/components/AutocompletePopup/Products/ProductsContainer.vue';
import SuggestionsContainer from '@/components/AutocompletePopup/ShowResults/Suggestions/SuggestionsContainer.vue';
import MoreResultsButton from '@/components/AutocompletePopup/ShowResults/Results/MoreResultsButton.vue';
import {computed, inject, ref} from 'vue';
import {SmartSearchConfigInterface, SmartSearchTranslationsInterface} from '@/core/types';
import {storeToRefs} from "pinia";
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";

const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!);
const suggestionsEnabled = SmartSearchConfig.value.autocomplete.suggestions.enabled;
const bestsellerEnabled = SmartSearchConfig.value.autocomplete.bestseller.enabled;

const searchQueryStore = useSearchQueryStore();
const { searchQuery } = storeToRefs(searchQueryStore);
const popupStore = usePopupStore();
const {
  getAutocompleteResults,
  hasNoResults,
  getAutocompleteResultsWithoutFirst,
  getBestseller,
  canShowPromotedSection
} = storeToRefs(popupStore);

const customRedirects = window?._QONizer?.customSmartSearchConfig?.customRedirects || [];

const matchedRedirect = computed(() => {
  const queryLower = searchQuery.value.toLowerCase().trim();
  return customRedirects.find(redirect => redirect.phrases.some(phrase => phrase.toLowerCase() === queryLower));
});

// Funkcja do formatowania tekstu (pierwsza litera każdego wyrazu wielka)
const capitalizeWords = (str: string) => {
  return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
};

const results = computed(() => {
  if (matchedRedirect.value) {
    const customItem = {
      type: 'custom',
      url: matchedRedirect.value.url,
      label: capitalizeWords(searchQuery.value) // Formatujemy label
    };
    return [customItem];
  }
  return bestsellerEnabled && canShowPromotedSection.value ? getAutocompleteResultsWithoutFirst.value : getAutocompleteResults.value;
});

const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!;
</script>

<style>
</style>